import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m.49 8 6-5.34c.14-.11.32-.13.47-.04.15.09.25.27.26.47V5.9c6.54 0 7.78 5.39 7.98 8.26.01.24-.11.45-.29.54-.18.09-.39.03-.53-.14-2.9-4.01-7.16-3.09-7.16-3.09v2.81a.58.58 0 0 1-.26.47c-.15.09-.33.08-.47-.04l-6-5.34C.31 9.22.2 8.96.2 8.69c0-.27.11-.53.29-.69z"
    }, null, -1)
  ])))
}
export default { render };